import React from 'react';
import { ErrorBoundary, QuoteFormErrorFallback } from '@/components/ui/ErrorBoundary';

// Core public page imports - COPIED EXACTLY from App.tsx
const Index = React.lazy(() => import('@/pages/Index'));
const Quote = React.lazy(() => import('@/pages/Quote'));
const TrackingPage = React.lazy(() =>
  import('@/pages/TrackingPage').then((m) => ({ default: m.TrackingPage })),
);

// Customer-facing Catalog imports - COPIED EXACTLY from App.tsx
const CatalogPage = React.lazy(() => import('@/pages/CatalogPage'));
const WorldClassCatalog = React.lazy(() => import('@/pages/WorldClassCatalog'));
const CollectionPage = React.lazy(() => import('@/pages/CollectionPage'));
const ProductDetailPage = React.lazy(() => import('@/pages/ProductDetailPage'));

// Public quote sharing imports - COPIED EXACTLY from App.tsx
const ShopifyStyleQuoteView = React.lazy(() => import('@/components/quotes/ShopifyStyleQuoteView'));

// 🔥 ENTERPRISE: Test page for form persistence
const TestEnterprisePersistence = React.lazy(() => import('@/pages/TestEnterprisePersistence'));

// Core public routes - Main application functionality
export const coreRoutes = [
  {
    index: true,
    element: <Index />,
  },
  {
    path: 'quote',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <Quote />
      </ErrorBoundary>
    ),
  },
  {
    path: 'track/:trackingId?',
    element: <TrackingPage />,
  },
  // Customer-facing Catalog Routes
  {
    path: 'catalog',
    element: <CatalogPage />,
  },
  {
    path: 'catalog-v2',
    element: <WorldClassCatalog />,
  },
  {
    path: 'catalog/:handle',
    element: <CollectionPage />,
  },
  {
    path: 'products/:handle',
    element: <ProductDetailPage />,
  },
  // Public quote sharing routes
  {
    path: 'quote/view/:token',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <ShopifyStyleQuoteView viewMode="guest" />
      </ErrorBoundary>
    ),
  },
  {
    path: 's/:shareToken',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <ShopifyStyleQuoteView viewMode="guest" />
      </ErrorBoundary>
    ),
  },
];